/* global define */

(((root, factory) => {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.svgCircleLoader = factory();
  }
})(this, () => {
  const ownProperty = Object.prototype.hasOwnProperty;

  const defaults = {
    where: document.body,
    useBg: true,
    width: 100,
    height: 100,
    cx: 50,
    cy: 50,
    r: 45,
    rotation: -90,
    strokeWidth: 6,
    strokeWidthBg: 10,
    stroke: '#bada55',
    strokeBg: '#ff69b4',
    perCent: 0,
    cssClass: 'loader',
    cssClassBg: 'loader-bg',
  };

  function SvgCircleLoader(where, options) {
    if (!options || typeof options !== 'object') {
      options = {};
    }

    if (!where || !where.nodeType) {
      where = defaults.where;
    } else if (where && !where.nodeType && typeof where === 'object') {
      options = where;
    }

    this.where = where;

    this.options = this.simpleExtend(defaults, options);

    this.options.strokedDasharray = 2 * Math.PI * this.options.r;

    this.valuePerPercent = this.options.strokedDasharray / 100;

    // valuePerPercent * (100 - percent)
    this.options.strokeDashoffset = this.givePerCent(this.options.perCent);

    this.draw();
  }

  // short
  SvgCircleLoader.fn = SvgCircleLoader.prototype;

  // one level deep
  // var a = {a: 1}; var b = {a: 2, b: 2}; var c = {a: 3, b: 3, c: 3};
  // var d = simpleExtend({}, a, b, c, {d: 1}); // -> {a: 3, b: 3, c: 3, d: 1}
  SvgCircleLoader.fn.simpleExtend = function (...args) {
    const returnObject = {};

    for (let i = 0, c = args.length; i < c; i++) {
      for (const j in args[i]) {
        if (ownProperty.call(args[i], j)) {
          returnObject[j] = args[i][j];
        }
      }
    }

    return returnObject;
  };

  SvgCircleLoader.fn.givePerCent = function (perCent) {
    return this.valuePerPercent * (100 - perCent);
  };

  SvgCircleLoader.fn.draw = function () {
    const o = this.options;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const svgNS = svg.namespaceURI;
    let bgCircle;

    if (o.useBg) {
      bgCircle = document.createElementNS(svgNS, 'circle');
      bgCircle.setAttribute('class', o.cssClassBg);
      bgCircle.setAttribute('cx', o.cx);
      bgCircle.setAttribute('cy', o.cy);
      bgCircle.setAttribute('r', o.r);
      bgCircle.setAttribute('stroke', o.strokeBg);
      bgCircle.setAttribute('stroke-width', o.strokeWidthBg);
      bgCircle.setAttribute('fill', 'none');
      svg.appendChild(bgCircle);
    }

    const mainCircle = document.createElementNS(svgNS, 'circle');

    mainCircle.setAttribute('transform', `rotate(${o.rotation} ${o.cx} ${o.cy})`);
    mainCircle.setAttribute('class', o.cssClass);
    mainCircle.setAttribute('cx', o.cx);
    mainCircle.setAttribute('cy', o.cy);
    mainCircle.setAttribute('r', o.r);
    mainCircle.setAttribute('stroke', o.stroke);
    mainCircle.setAttribute('stroke-width', o.strokeWidth);
    mainCircle.setAttribute('stroke-dashoffset', o.strokeDashoffset);
    mainCircle.setAttribute('stroke-dasharray', o.strokedDasharray);
    mainCircle.setAttribute('fill', 'none');
    svg.appendChild(mainCircle);
    svg.setAttribute('viewBox', `0 0 ${o.width} ${o.height}`);

    this.bgCircle = bgCircle;
    this.mainCircle = mainCircle;
    this.where.appendChild(svg);
  };

  SvgCircleLoader.fn.update = function (what, attr, val) {
    if (arguments.length < 3) {
      return;
    }

    what = what === 'main' ? this.mainCircle : this.bgCircle;

    if (/stroke-dashoffset|perCent/i.test(attr)) {
      what.style.strokeDashoffset = this.givePerCent(val);
    } else {
      what.setAttribute(attr, val);
    }
  };

  return (where, options) => // no need to use 'new'
    new SvgCircleLoader(where, options);
}));



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/svgCircleLoader.js